import { FileInput } from './fileInput';
import { IFileInputOptions } from '../../../interfaces/options';
import { Templates } from '../../../compile';

export class ImageFileInput extends FileInput {
	private preview: KnockoutObservable<string>;
	constructor(
		id: string,
		label: string,
		preview?: string | KnockoutObservable<string>,
		options?: IFileInputOptions
	) {
		options = $.extend(
			true,
			{},
			<IFileInputOptions>{
				widget: {
					widget: Templates.widgets_imageFileInput
				},
				fileSizeLimit: 4 * 1024 * 1024 //4MB as B
			},
			options || {}
		);
		super(id, label, options);
		this.preview = preview
			? ko.isObservable(preview)
				? <KnockoutObservable<string>>preview
				: ko.observable(<string>preview)
			: ko.observable<string>();
		this.fileName.subscribe(newFileName => {
			if (newFileName) {
				var reader = new FileReader();
				reader.onload = (e: any) => {
					this.preview(e.target.result);
				};
				reader.readAsDataURL(this.fileElement().files[0]);
			}
		});
	}
}
